import { render, staticRenderFns } from "./MissingCorridors.vue?vue&type=template&id=76224354&scoped=true&"
import script from "./MissingCorridors.vue?vue&type=script&lang=js&"
export * from "./MissingCorridors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76224354",
  null
  
)

export default component.exports